import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// Your web app's Firebase configuration (kbt-frontend project)
const firebaseConfig = {
  apiKey: 'AIzaSyBoLfl8vYeJTJ99GrCjTznFs_DyOX9kzr8',
  authDomain: 'kbt-frontend.firebaseapp.com',
  projectId: 'kbt-frontend',
  storageBucket: 'kbt-frontend.firebasestorage.app',
  messagingSenderId: '912141774285',
  appId: '1:912141774285:web:2bb51f5c84ca58abdf2884',
  measurementId: 'G-9LE8B6HXKG',
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Get auth instance (using compat SDK consistently)
const auth = firebase.auth();

// Detect localhost for development mode
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]'
);

// Disable reCAPTCHA verification on localhost (use Firebase test phone numbers instead)
if (isLocalhost) {
  auth.settings.appVerificationDisabledForTesting = true;
}

// OAuth Providers
const googleProvider = new firebase.auth.GoogleAuthProvider();
const appleProvider = new firebase.auth.OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

// Firestore
const db = firebase.firestore();

// Phone Auth: ALWAYS mount reCAPTCHA on document.body. Putting the widget
// inside the verification modal (overflow + MUI focus trap) is why SMS
// often never sends on phones — Google considers the widget not visible
// and returns auth/invalid-app-credential, or the iframe never receives
// the tap. z-index sits above MUI Modal (1300).
const RECAPTCHA_CONTAINER_ID = 'firebase-phone-recaptcha-container';

const setupRecaptcha = (_containerId, options = {}) => {
  const { onSolved, onExpired, invisible } = options;
  const size = invisible ? 'invisible' : 'normal';
  const targetId = invisible
    ? `${RECAPTCHA_CONTAINER_ID}-invisible`
    : RECAPTCHA_CONTAINER_ID;
  return new Promise((resolve, reject) => {
    // Clear previous verifier
    if (window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier.clear();
      } catch (e) {
        // Ignore
      }
      window.recaptchaVerifier = null;
    }

    let container = document.getElementById(targetId);
    if (container) {
      container.innerHTML = '';
    } else {
      container = document.createElement('div');
      container.id = targetId;
      if (invisible) {
        container.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      } else {
        container.style.cssText =
          'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:10000;background:#fff;padding:8px;border-radius:8px;box-shadow:0 2px 12px rgba(0,0,0,0.18);';
      }
      document.body.appendChild(container);
    }

    try {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(targetId, {
        size,
        callback: () => {
          window.recaptchaSolved = true;
          onSolved?.();
        },
        'expired-callback': () => {
          window.recaptchaSolved = false;
          onExpired?.();
        },
      });

      window.recaptchaVerifier
        .render()
        .then((widgetId) => {
          window.recaptchaWidgetId = widgetId;
          resolve(window.recaptchaVerifier);
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
};

const sendOTP = async (phoneNumber, recaptchaVerifier) => {
  try {
    // Using firebase.auth().signInWithPhoneNumber (compat SDK)
    const confirmationResult = await auth.signInWithPhoneNumber(phoneNumber, recaptchaVerifier);
    return { success: true, confirmationResult };
  } catch (error) {
    console.error('Firebase sendOTP error:', error.code, error.message);
    const errorString = error.code ? `${error.code}: ${error.message}` : error.message;
    return { success: false, error: errorString, code: error.code };
  }
};

const verifyOTP = async (confirmationResult, otp) => {
  try {
    const result = await confirmationResult.confirm(otp);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('Firebase verifyOTP error:', error.code, error.message);
    const errorString = error.code ? `${error.code}: ${error.message}` : error.message;
    return { success: false, error: errorString, code: error.code };
  }
};

const linkPhoneToAccount = async (user, phoneCredential) => {
  try {
    const result = await user.linkWithCredential(phoneCredential);
    return { success: true, user: result.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Export PhoneAuthProvider from firebase compat
const PhoneAuthProvider = firebase.auth.PhoneAuthProvider;

export {
  auth,
  googleProvider,
  appleProvider,
  firebaseApp,
  db,
  setupRecaptcha,
  sendOTP,
  verifyOTP,
  linkPhoneToAccount,
  PhoneAuthProvider,
  firebase,
  isLocalhost,
};
